import { IApiBaseResponse } from '~/utils/interface/common';
import axiosClient from './axiosClient';
import {
  IBodyCreateEstimateTemplate,
  IParamsGetEstimateTemplates,
  IResponseGetEstimateTemplate,
  IResponseGetEstimateTemplates,
} from '~/utils/interface/estimate-template';
import { IPayloadDeleteTemplates } from '~/utils/interface/template';

const estimateTemplateApi = {
  createEstimateTemplate(data: IBodyCreateEstimateTemplate) {
    return axiosClient.post<IApiBaseResponse<IBodyCreateEstimateTemplate>>(`api/admin/estimate-templates`, data);
  },

  getEstimateTemplates(params: IParamsGetEstimateTemplates) {
    return axiosClient.get<IApiBaseResponse<IResponseGetEstimateTemplates>>(`api/admin/estimate-templates`, {
      params,
    });
  },

  getEstimateTemplate(id: string) {
    return axiosClient.get<IApiBaseResponse<IResponseGetEstimateTemplate>>(`api/admin/estimate-templates/${id}`);
  },
  deleteEstimateTemplate(data: IPayloadDeleteTemplates) {
    return axiosClient.delete<IApiBaseResponse<null>>(`api/admin/estimate-templates`, { data });
  },
  updateEstimateTemplate(id: string, data: IBodyCreateEstimateTemplate) {
    return axiosClient.put<IApiBaseResponse<IBodyCreateEstimateTemplate>>(`api/admin/estimate-templates/${id}`, data);
  },
  createUploadFiles(data: FormData) {
    return axiosClient.post<IApiBaseResponse<null>>(`api/admin/estimates/uploadFiles`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export default estimateTemplateApi;
